import { render, staticRenderFns } from "./GenerateCertificate.vue?vue&type=template&id=2695d508&scoped=true&"
import script from "./GenerateCertificate.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificate.vue?vue&type=style&index=0&id=2695d508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695d508",
  null
  
)

export default component.exports